module.exports = __webpack_public_path__ + "img/48.ec17aa46.svg";